import React from "react";
import { Container } from "semantic-ui-react";
import ProductListItem from "./ProductListItem";

export default function ProductList({ cards }) {
  return (
    <Container>
      {cards.map((card) => (
        <ProductListItem card={card} key={card.id} />
      ))}
    </Container>
  );
}
